import { checkAuth } from "../auth/AuthContext";
import { parsePayload, throwCommError, OperationError } from "../DAO";
import { Instance } from "./Instance";


export async function listInstances(): Promise<Instance[]> {
   const payload = await fetch('../admin/instance/list', {
      'method': 'POST',
      'headers': {
         'Accept': 'application/json'
      }
   }).catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth);
   if (payload.success) {
      let value: any[];
      if (Array.isArray(payload.value)) {
         value = payload.value;
      }
      else {
         value = [];
      }
      return value.map(Instance.parse);
   }
   throw OperationError.from(payload);
}

export async function renameInstance(id: number, name: string): Promise<void> {
   return submitInstanceAction("rename", { id, name });
}

export async function addInstance(name: string): Promise<void> {
   return submitInstanceAction("add", { name });
}

type FormData = {
   id?: number;
   name: string
}
async function submitInstanceAction(command: string, formData: FormData): Promise<void> {
   return fetch(`../admin/instance/${command}`, {
      'method': 'POST',
      'headers': {
         'Content-Type': 'application/json',
         'Accept': 'application/json'
      },
      'body': JSON.stringify(formData)
   }).catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth)
      .then(payload => {
         if (!payload.success) {
            throw OperationError.from(payload);
         }
         return;
      });
}
